export default __webpack_public_path__ + "static/media/case-study-12-submarine-availability.88c2803c.mp4";